exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".container-3Q9yB {\n  width: 100%;\n  margin: 0 0 0.5rem;\n}\n.container-3Q9yB .button-1PA2D {\n  padding: 0.5rem 2rem;\n  height: 40px;\n}\n.fullWidth-2568B {\n  display: -webkit-box;\n  display: -webkit-flex;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-align: end;\n  -webkit-align-items: flex-end;\n  -ms-flex-align: end;\n  align-items: flex-end;\n}\n.fullWidth-2568B .button-1PA2D {\n  margin-left: 1rem;\n}\n.stacked-3Atfp {\n  display: block;\n}\n.stacked-3Atfp .button-1PA2D {\n  display: block;\n  margin: 1rem 0 2rem;\n}\n.input-T19DV input[type=text] {\n  -webkit-box-sizing: content-box;\n  box-sizing: content-box;\n  padding: 0.5rem 1rem;\n  border: none;\n}", ""]);

// Exports
exports.locals = {
	"container": "container-3Q9yB",
	"button": "button-1PA2D",
	"fullWidth": "fullWidth-2568B",
	"stacked": "stacked-3Atfp",
	"input": "input-T19DV"
};